module.exports = __webpack_public_path__ + "static/media/Circo2025_25.2c4e0881.webp";